import { computed, reactive, useContext } from "@nuxtjs/composition-api";
import { useUserStore } from "~/stores/user";

const STEPS = {
  start: "start",
  problem: "problem",
  smsLogin: "smsLogin",
  addEmail: "addEmail,",
};

const initState = () => ({
  tenderData: null,
  step: STEPS.start,
  jobDone: true,
  person: null,
});

const state = reactive(initState());

function reset() {
  Object.assign(state, initState());
}

function restart() {
  state.step = STEPS.start;
}

function failure() {
  state.step = STEPS.problem;
}

export function useRating() {
  const context = useContext();
  const userStore = useUserStore(context.$pinia);

  const isStartStep = computed(() => state.step === STEPS.start);
  const isProblemStep = computed(() => state.step === STEPS.problem);
  const isSmsLoginStep = computed(() => state.step === STEPS.smsLogin);
  const isAddEmailStep = computed(() => state.step === STEPS.addEmail);

  async function init(seoName) {
    if (process.server) {
      throw new Error("init should be called only on client");
    }
    state.step = STEPS.start;
    // if (!rootGetters['professional/person']) {
    try {
      const PERSON_BY_SEONAME = await import("./personBySeoName.graphql");
      const resp = await context.$query(PERSON_BY_SEONAME, { seoName });
      if (resp.redirect) {
        // TODO redirect to new url
      }
      if (resp.personBySeoName) {
        state.person = resp.personBySeoName;
        loadLastTenderData();
      }
    } catch (err) {
      return err;
    }
  }

  async function loadLastTenderData() {
    if (userStore.me) {
      try {
        const LAST_TENDER_WITH = await import("./getLastTenderWith.graphql");
        const lastTenderWith = await context.$query(LAST_TENDER_WITH, {
          seoName: context.route.value.params.professionalSeoName,
        });
        if (lastTenderWith?.getLastTenderWith?.data) {
          state.tenderData = lastTenderWith.getLastTenderWith.data;
        }
      } catch (err) {
        console.error(err, "loadLastTenderData");
        context.$sentry.captureException(err, {
          tags: {
            action: "loadLastTenderData",
            source: "useRating.js",
          },
        });
      }
    }
  }

  async function nextStep() {
    if (process.server) {
      throw new Error("nextStep should be called only on client");
    }
    const user = userStore.me;
    if (state.jobDone) {
      if (!user) {
        // user not logged in, make them log in
        state.step = STEPS.smsLogin;
      } else if (!user.email) {
        // user does not have email, make them add email
        state.step = STEPS.addEmail;
      } else if (state.tenderData) {
        // go to score link
        window.open(state.tenderData.scoreLink);
        restart();
      } else {
        await loadLastTenderData();
        if (!state.tenderData) {
          // No tender between user and professional, go to problem
          failure();
        } else {
          // go to score link
          window.open(state.tenderData.scoreLink);
          restart();
        }
      }
    } else if (!user) {
      // user not logged in, make them log in
      state.step = STEPS.smsLogin;
    } else {
      window.open(
        `https://joszaki.typeform.com/to/sgQvuMQW#mate_id=${state.person.id}&customer_id=${user.id}&type=customer_contact_mate`
      );
      restart();
    }
  }

  return {
    isStartStep,
    isProblemStep,
    isSmsLoginStep,
    isAddEmailStep,
    reset,
    nextStep,
    init,
    state,
    restart,
  };
}
